import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrustPaymentPage } from './trust-payment.page';

const routes: Routes = [
  {
    path: '',
    component: TrustPaymentPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrustPaymentPageRoutingModule {}
